// removed by extract-text-webpack-plugin
module.exports = {"root":"C0vMw","player":"Ga15p"};


//////////////////
// WEBPACK FOOTER
// ../source/components/VideoPlayer/styles.css
// module id = 1628
// module chunks = 6